import React, { useRef } from "react";

import { IDoubleProps } from "components/dashboard/product-template-table/utils/interfaces";
import { handlePrecision } from "components/dashboard/product-template-table/utils/utils";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";

export default function Double({
  value,
  unit,
  selectionValues,
  precision,
  formatNumber,
  changeHandler,
  isInEditMode,
}: IDoubleProps) {
  const myRef = useRef<HTMLInputElement>(null);

  const onSelect = (e: DropdownChangeEvent) => {
    changeHandler(parseFloat(e.value));
  };

  const handleChangeValue = (val: string) => {
    if (val !== null && val !== undefined) {
      const changedVal = val.replaceAll(",", ".");
      if (!Number.isNaN(Number(changedVal))) {
        changeHandler(changedVal);
      }
    } else {
      changeHandler("");
    }
  };

  if (isInEditMode) {
    if (selectionValues && selectionValues.length > 0) {
      return (
        <Dropdown
          value={value}
          style={{ width: "100%", textAlign: "left" }}
          options={selectionValues}
          placeholder={String(value)}
          onChange={e => onSelect(e)}
          required
        />
      );
    }
    return (
      <div
        className="p-inputtext p-d-flex p-jc-between"
        style={{ padding: "0" }}
        onClick={() => myRef.current?.focus()}
      >
        <input
          ref={myRef}
          className="p-inputtext"
          style={{ border: "none", float: "left", width: "100%" }}
          value={handlePrecision(value, precision)}
          onChange={e => handleChangeValue(e.target.value)}
          onFocus={e => e.target.select()}
        />
        {unit && unit.replaceAll(" ", "") && (
          <label style={{ padding: "12px" }}>{` ${unit}`}</label>
        )}
      </div>
    );
  }
  return (
    <div
      className="p-inputtext"
      style={{ whiteSpace: "nowrap", backgroundColor: "inherit", color: "inherit", border: "none" }}
    >
      {`${handlePrecision(value, precision, true, formatNumber)} ${unit}`}
    </div>
  );
}
